export const filterCriteria = [
  {
    label: "Type",
    code: "productCategoryType",
    field: { type: "input", label: "Type" },
    isPartial: true,
  },
  {
    label: "Name",
    code: "name",
    field: { type: "input", label: "Name" },
    isPartial: true,
  },
  {
    label: "Quantity Type",
    code: "quantityType",
    field: { type: "input", label: "Type" },
    isPartial: true,
  },
];

export const searchColumnHeaders = [
  {
    id: "select",
    type: "button",
    action: "selectItem",
    position: "sticky",
    iconName: "hand-pointer",
    ariaLabel: "Open",
  },
  {
    title: "Type",
    id: "productCategoryType"
  },
  {
    title: "Name",
    id: "name",
  },
  {
    title: "Quantity Type",
    id: "quantityType",
  },
];

export const defaultStateCategoryType = {
  _id: "NEW",
  name: "",
  productCategoryType: "",
};
